'use strict'

const config = {
  basePath: '',
  home: 'https://www.argos.co.uk',
  domain: 'www.argos.co.uk',
  xhrPath: '/finder-api', // Path for XHR to be served from
  xhrTimeout: 5000,
  httpStatusCodes: {
    success: 200,
    serverError: 500,
    serviceUnavailable: 503,
    notFound: 404,
    permanentRedirect: 301,
    temporaryRedirect: 302
  },
  getProductPath: (partNumber) => {
    return `product/${partNumber}`
  },
  globalFilterIds: ['fasttrack', 'price', 'customer rating'],
  dfp: {
    channelId: 42685526,
    enabled: true
  }
}

const sortByValues = [{
  'key': 'price_asc',
  'value': {
    'type': 'price',
    'order': 'asc'
  },
  'label': 'Price: Low - High',
  'path': 'sort:price'
}, {
  'key': 'price_desc',
  'value': {
    'type': 'price',
    'order': 'desc'
  },
  'label': 'Price: High - Low',
  'path': 'sort:price:desc'
}, {
  'key': 'customer rating_desc',
  'value': {
    'type': 'customer rating',
    'order': 'desc'
  },
  'label': 'Customer Rating',
  'path': 'sort:customer-rating'
}]

config.searchSortByValues = [{
  'key': 'relevance_desc',
  'value': {
    'type': 'relevance',
    'order': 'desc'
  },
  'label': 'Relevance',
  'path': ''
}, ...sortByValues]

config.browseSortByValues = [{
  'key': 'relevance_desc',
  'value': {
    'type': '',
    'order': ''
  },
  'label': 'Relevance',
  'path': ''
}, ...sortByValues]

const categoryTypes = {
  PLP: 'PLP',
  CLP: 'CLP',
  PLPPLUS: 'PLPPLUS',
  SUBHEADING: 'SUBHEADING',
  TOPLEVELCATEGORY: 'TOPLEVELCATEGORY',
  MASTERCATEGORY: 'MASTERCATEGORY'
}

const contentAreaTypes = {
  BackgroundImageGrid: 'GL018',
  GridLayoutThree: 'GL003',
  NavigationComponent: 'M012',
  BackgroundHeading: 'M0092',
  ContentInList: 'M053'
}

const contentAreaIds = {
  AreaB: 'B',
  AreaD: 'D',
  SeoArea: 'SEO',
  Dfp: {
    top: 'DFPTOP',
    bottom: 'DFPBOTTOM'
  },
  ContentInListArea: 'G'
}

const seoMetaPlaceholders = {
  category: '{{cat}}',
  refinement: '{{ref}}',
  brand: '{{brand}}',
  categoryFallback: '{{cat}} | {{brand}}',
  categoryRefinedFallback: '{{ref}} {{cat}} | {{brand}}'
}

const searchTypes = {
  brandsNIC: 'nic',
  didYouMean: 'dym',
  spellChecked: 'sc',
  NRS: 'nrs'
}

config.adSense = {
  stopWords: ['our', 'best', 'deals', 'on', 'for', 'fantastic', 'offers', 'at', 'argos', 'under', 'shop', 'savings', 'great', 'all', 'shop', 'day', 'amazing', 'seven', 'stock', 'limited', 'selected', 'home and garden', 'Technology', 'pounds', '2 for', 'sports and leisure', 'Jewellery and watches', 'Health and beauty', 'see', 'wow', 'under', 'beginner'],
  browse: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 6768544131,
        noResults: 7386168737
      },
      mobile: {
        SLP: 4222615939,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  },
  search: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 8745955930,
        noResults: 7386168737
      },
      mobile: {
        SLP: 7269222731,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  }
}

const getBrandVocab = (brand) => {
  return {
    'argos': '',
    'habitat': 'PROD Habitat Navigation'
  }[brand]
}

export {
  categoryTypes,
  contentAreaTypes,
  contentAreaIds,
  seoMetaPlaceholders,
  searchTypes,
  getBrandVocab
}
export default config
